
import { Link, useLocation } from "react-router-dom";
import { Home, User, Plus, Briefcase, List } from "lucide-react";
import { useProfile } from "@/contexts/ProfileContext";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useState } from "react";
import { CreateJobDialog } from "../job/CreateJobDialog";
import { MobileProfileMenu } from "./MobileProfileMenu";

export function MobileBottomNav() {
  const location = useLocation();
  const { profile } = useProfile();
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [sheetOpen, setSheetOpen] = useState(false);

  // Use profile role to determine if user is employer
  const isEmployer = profile?.role === 'employer' || profile?.role === 'administrator';

  const isActivePage = (path: string) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path === "/test-management" && location.pathname === "/test-management") return true;
    if (path === "/jobs" && (location.pathname === "/jobs" || location.pathname.startsWith("/job/"))) return true;
    if (path === "/profile" && location.pathname === "/profile") return true;
    return false;
  };

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border flex items-center justify-around h-16">
        <Link 
          to="/" 
          className={`flex flex-col items-center justify-center p-2 ${
            isActivePage("/") 
              ? "text-foreground" 
              : "text-muted-foreground"
          }`}
        >
          <Home className="h-6 w-6" />
          <span className="text-xs mt-1">Home</span>
        </Link>

        {isEmployer ? (
          <Link 
            to="/test-management" 
            className={`flex flex-col items-center justify-center p-2 ${
              isActivePage("/test-management") 
                ? "text-foreground" 
                : "text-muted-foreground"
            }`}
          >
            <List className="h-6 w-6" />
            <span className="text-xs mt-1">Tests</span>
          </Link>
        ) : (
          <Link 
            to="/jobs" 
            className={`flex flex-col items-center justify-center p-2 ${
              isActivePage("/jobs") 
                ? "text-foreground" 
                : "text-muted-foreground"
            }`}
          >
            <Briefcase className="h-6 w-6" />
            <span className="text-xs mt-1">Jobs</span>
          </Link>
        )}

        {isEmployer && (
          <button
            onClick={() => setShowCreateDialog(true)}
            className="flex flex-col items-center justify-center p-2 text-muted-foreground"
          >
            <Plus className="h-6 w-6" />
            <span className="text-xs mt-1">Create</span>
          </button>
        )}

        <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
          <SheetTrigger asChild>
            <button
              className={`flex flex-col items-center justify-center p-2 ${
                isActivePage("/profile") 
                  ? "text-foreground" 
                  : "text-muted-foreground"
              }`}
            >
              <User className="h-6 w-6" />
              <span className="text-xs mt-1">Profile</span>
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[85vw] sm:max-w-md pt-12">
            <MobileProfileMenu />
          </SheetContent>
        </Sheet>
      </div>

      <CreateJobDialog 
        open={showCreateDialog}
        onOpenChange={setShowCreateDialog}
      />
    </>
  );
}
